import moment from 'moment';
export const durationToSchema = duration => {
  return moment.utc(moment.duration(duration, 'seconds').as('milliseconds')).format('[PT]HH[H]mm[M]ss[S]');
};